import "./home.scss";
import down from "../../images/down1.png";


const Hom = () => {
  return (
    <div id="home" className="container-home w-screen h-screen shrink ">
      <div className="c">
        <div className="information">
          <div className="font-face-nh">
            <h1 className="first-name">Shreyas</h1>
            <h1 className="last-name font-face-nh">Chaliha</h1>
          </div>
          {/* </motion.div> */}
          <div className="flex w-12 h-12 ml-32 absolute inset-x-0 bottom-2 button-0 animate-bounce">
            <img src={down} alt="down" />
            <h3 className="text-white ml-2">Scroll Down</h3>
          </div>
        </div>
      </div>

      <div className="c cr justify-center">
        <div className="mt-[15vh] ml-[10vw] mr-[8vw] mb-[40vh] flex flex-wrap justify-center gap-4 text-left w-screen sha">
          <div className="site-title w-full h-full ">
            <p className="text-xl md:text-2xl lg:text-4xl 2xl:text-5xl">
              I'm a creator in the digital realm, using my skills to craft
              innovative web solutions that bring ideas to life.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hom;
